module.exports = __webpack_public_path__ + "img/GYLFW_7.a1791731.jpg";